/**
 * Input guards for number fields, applied as the user types (the server re-checks everything).
 * The Razor portal does the same in wwwroot/js/site.js, driven by each input's step and max.
 */

/** Money: at most 2 decimal places. */
export const MONEY_DECIMALS = 2;

/** Request rate limit: whole numbers up to 10,000 (ClientPlanService.MaxRateLimit). */
export const MAX_RATE_LIMIT = 10_000;

/**
 * The text to keep for a typed value: cut to `decimals` places (0 = whole numbers only) and capped
 * at `max` when given. Cutting, not rounding: what the user typed is never rounded up.
 */
export function limitNumberInput(raw: string, decimals: number, max?: number): string {
  if (raw === '' || raw === '-') return raw;
  let text = raw;
  const dot = text.indexOf('.');
  if (dot >= 0) text = decimals === 0 ? text.slice(0, dot) : text.slice(0, dot + 1 + decimals);
  if (max !== undefined && Number(text) > max) text = String(max);
  return text;
}

/** Decimal places a step allows: "0.01" → 2, "1" → 0. */
export function decimalsOfStep(step: string | number): number {
  const s = String(step);
  const dot = s.indexOf('.');
  return dot < 0 ? 0 : s.length - dot - 1;
}

/** For a money field: 2 decimals, optional cap. */
export const money = (raw: string, max?: number) => limitNumberInput(raw, MONEY_DECIMALS, max);

/** For a rate-limit field: whole numbers, at most 10,000. */
export const rateLimitInput = (raw: string) => limitNumberInput(raw, 0, MAX_RATE_LIMIT);
